<template>

  <div>

    <div v-if="editorOpen">

      <div style="position: fixed; right: 20px; top: 10px; z-index: 1000001">

        <b-button variant="outline-primary" class="mr-3" @click="rotate('left')">
          <b-icon-arrow-counterclockwise/>
          Esquerda
        </b-button>

        <b-button variant="outline-primary" class="mr-3" @click="rotate('right')">
          <b-icon-arrow-clockwise/>
          Direita
        </b-button>

        <b-button variant="outline-primary" class="mr-3" v-show="blackoutImageBackup" @click="confirmBackup">
          <b-icon-cloud-arrow-up/>
          Restaurar
        </b-button>

        <t-button danger class="mr-3" @click="closeEditor">Cancelar</t-button>

        <b-button variant="primary" :disabled="onSendingEditedImage" @click="saveEditedImage">
          <b-icon-check-circle-fill class="mr-2"/>
          Salvar Edição
        </b-button>

      </div>

      <t-image-blob
          style="cursor: zoom-out"
          class="align-self-center"
          :blob="blackoutImageZoomImage"/>

      <tui-image-editor ref="tuiImageEditor"
                        style="width: 100%; height: 100%; position: fixed; left: 0; top:0; z-index: 1000000;"
                        :options="editorOptions">
      </tui-image-editor>


    </div>

    <t-blackout @onOpen="onBlackoutImage(true)" @onClose="onBlackoutImage(false)" v-model="blackoutImageZoom"
                :no-close-on-esc="editorOpen"
                :busy="blackoutImageZoomBusy">

      <template #buttons-top-appendage>

        <div class="container-buttons-upload-images">

          <b-button @click="openEditorPhoto" v-show="!onlyView" variant="primary" class="mr-2"
                    style="padding: .475rem .85rem;">
            <b-icon-brush/>
            Editar
          </b-button>

        </div>

      </template>

      <template #default>


        <div class="d-flex align-content-center justify-content-center overflow-hidden"
             style="max-width: 100vh; max-height: 80vh">

          <div style="width: 100px" class="d-flex justify-content-center align-items-center">
            <i class="fa fa-arrow-circle-left opacity-6-hover hover" v-show="blackoutImageIndex>0"
               @click="openImage('L',0,false)" style="font-size: 40px"></i>
          </div>
          <div>


            <b-row>

              <b-col cols="6">

                <div style="color: #FFFFFF; text-align: left"
                     class="container-title-text ml-3">Imagem {{
                    blackoutImageIndex + 1
                  }}/{{ items.length }}
                </div>

              </b-col>

              <b-col cols="6" class="text-right">

                <t-help class="container-title-text" v-show="blackoutImageIndex >= 0"
                        :title="'Data da Criação:<br /><b>'+ ui.convertDateBR(items[blackoutImageIndex].logControl.createdDate,true) +'</b><br />Responsável:<br /><b>'+items[blackoutImageIndex].logControl.createdUser+'</b>'"/>

                <b-icon-arrow-down-circle v-b-tooltip.hover.ds500 title="Download da Imagem"
                                          class="hover container-title-text text-black-75 opacity-6-hover ml-3"
                                          @click="downloadImage(items[blackoutImageIndex])"/>


                <b-icon-search v-b-tooltip.hover.ds500 title="Zoom na Imagem"
                               class="hover container-title-text text-black-75 opacity-6-hover ml-3"
                               @click="zoomImage(items[blackoutImageIndex])"/>


                <b-icon-trash v-b-tooltip.hover.ds500 title="Excluir Imagem"
                              v-if="userAuth.validation.validationDelete && command !== 'view' && !onlyView"
                              class="hover container-title-text opacity-6-hover ml-2"
                              style="color:#981a38 !important;"
                              @click="itemDelete(orderItems[blackoutImageIndex][primaryKeyColumn], true)"/>


              </b-col>

            </b-row>


            <!--FEITO ISSO PARA CORRIGIR IMAGENS HORIZONTAIS max-height: 50vh; overflow: hidden-->
            <div @click="zoomImage(orderItems[blackoutImageIndex])"
                 style="cursor: zoom-in; display: flex; justify-content: center; align-content: center">

              <t-image-blob v-show="!blackoutImageZoomBusy"
                            :class="{'integration-utilized':checkIntegrationStatus(items[blackoutImageIndex].integrationStatus),['blackout-image-full-orientation-'+blackoutImageOrientation]:blackoutImageOrientation!==''}"
                            class="align-self-center m-2" :blob="blackoutImageZoomImage"/>

            </div>

            <div v-if="checkIntegrationStatus(items[blackoutImageIndex].integrationStatus)">
              <b-badge variant="warning">
                <b-icon-star-fill/>
                - Imagem utilizada em integração customizada
              </b-badge>

            </div>


            <div v-if="specialTypeEvidenceFile">

              <div v-if="businessEvidenceFileRequiredFields === 'N'">
                <t-input
                    placeholder="Editar Legenda"
                    label="Legenda"
                    rows="3"
                    cols="12"
                    textarea
                    :fixed="!userAuth.validation.validationUpdate || (command === 'view'  || onlyView)"
                    @focusout="updateEvidenceFile()"
                    v-model="evidenceFileEntityUpdate.subtitle"/>
              </div>

              <div v-else>

                <b-row class="text-left">

                  <t-input
                      :label=businessEvidenceFileRequiredFieldsObject.categoryLabel
                      :fixed="!userAuth.validation.validationUpdate || (command === 'view'  || onlyView)"
                      cols="6"
                      v-show="businessEvidenceFileRequiredFieldsObject.categoryShow"
                      class="col-md-6 col-sm-12"
                      select-common :options="typeEvidenceCategoryOptions"
                      @change="updateEvidenceFile()"
                      v-model="evidenceFileEntityUpdate.typeEvidenceCategoryId"/>

                  <b-col cols="6" v-show="businessEvidenceFileRequiredFieldsObject.serviceShow"
                         class="col-md-6 col-sm-12">

                    <div class="d-flex" style="justify-content: space-between">

                      <div class="container-title-text">{{businessEvidenceFileRequiredFieldsObject.serviceLabel}}</div>

                      <b-form-checkbox
                          :disabled="!userAuth.validation.validationUpdate || (command === 'view'  || onlyView)"
                          v-model="evidenceFileEntityUpdate.typeEvidenceServiceNotFound" switch>

                        <small class="container-title-text">Outro?</small>

                      </b-form-checkbox>

                    </div>

                    <t-input v-show="!evidenceFileEntityUpdate.typeEvidenceServiceNotFound"
                             v-model="evidenceFileEntityUpdate.typeEvidenceServiceId"
                             :fixed="!userAuth.validation.validationUpdate || (command === 'view'  || onlyView)"

                             hide-label label="Serviço" select-common :options="typeEvidenceServiceOptions"
                             @change="updateEvidenceFile()"/>

                    <t-input v-show="evidenceFileEntityUpdate.typeEvidenceServiceNotFound"
                             :fixed="!userAuth.validation.validationUpdate || (command === 'view'  || onlyView)"
                             v-model="evidenceFileEntityUpdate.typeEvidenceServiceNotFoundOther"
                             hide-label label="Serviço - Outro" placeholder="Informe o serviço desejado"
                             @focusout="updateEvidenceFile()"/>


                  </b-col>


                </b-row>

                <b-row class="text-left">

                  <t-input
                      label="Status"
                      v-show="businessEvidenceFileRequiredFieldsObject.statusShow"
                      :fixed="!userAuth.validation.validationUpdate || (command === 'view'  || onlyView)"
                      cols="6"
                      class="col-md-6 col-sm-12"
                      select-common :options="typeEvidenceStatusOptions"
                      @change="updateEvidenceFile()"
                      v-model="evidenceFileEntityUpdate.typeEvidenceStatusId"/>

                  <t-input :placeholder="businessEvidenceFileRequiredFieldsObject.complementLabel"
                           :label="businessEvidenceFileRequiredFieldsObject.complementLabel"
                           v-show="businessEvidenceFileRequiredFieldsObject.complementShow"
                           :fixed="!userAuth.validation.validationUpdate || (command === 'view'  || onlyView)"
                           cols="6"
                           class="col-md-6 col-sm-12"
                           @focusout="updateEvidenceFile()"
                           v-model="evidenceFileEntityUpdate.environmentComplement"/>

                </b-row>

                <t-input
                    placeholder="Editar atividades"
                    label="Observações"
                    textarea
                    max-length="1000"
                    cols="12"
                    :fixed="!userAuth.validation.validationUpdate || (command === 'view'  || onlyView)"
                    @focusout="updateEvidenceFile()"
                    v-model="evidenceFileEntityUpdate.subtitle"/>

              </div>


            </div>
            <div v-else style="text-align: center">

              <b-row class="text-left">

                <t-input placeholder="Editar Legenda"
                         label="Legenda"
                         textarea
                         rows="5"
                         :fixed="!userAuth.validation.validationUpdate || (command === 'view'  || onlyView)"
                         :cols="(categoryOptions !== null && categoryOptions !== undefined && categoryOptions.length > 0) ? 6 : 12"
                         @focusout="updateFile('image')"
                         v-model="blackoutImageSubtitle"/>

                <t-input
                    label="Momento"
                    v-if="categoryOptions !== null && categoryOptions !== undefined && categoryOptions.length > 0"
                    :fixed="!userAuth.validation.validationUpdate || (command === 'view'  || onlyView)"
                    cols="6"
                    select-common
                    :options="categoryOptions"
                    @change="updateFile('image')"
                    v-model="blackoutImageCategoryId"/>

              </b-row>

            </div>


          </div>

          <div style="width: 100px" class="d-flex justify-content-center align-items-center">
            <i class="fa fa-arrow-circle-right opacity-6-hover hover" v-show="blackoutImageIndex<(orderItems.length-1)"
               @click="openImage('R',0,false)" style="font-size: 40px"></i>
          </div>

        </div>

      </template>


    </t-blackout>

    <t-msg fade warning v-if="messageNotRecord !== '' && orderItems.length === 0">{{ messageNotRecord }}</t-msg>

    <transition mode="out-in"
                enter-active-class="animated fadeInFast">

      <b-col v-if="!busy && thumbLoad" class="fadeIn mb-5" cols="12">

        <transition name="fade-fast">

          <div v-show="checkValidation()">

            <validation-observer v-slot="{invalid,errors}">

              <span class="display-none">
                {{ errorList = errors }}
                {{ isInvalid = invalid }}
              </span>

              <b-row style="margin-left: -5px; margin-right: -5px;" :class="{'form-loading':busyForm}">

                <slot>

                  <b-col cols="12" class="mb-2"
                         v-if="command !== 'view' && !onlyView && userAuth.validation.validationCreate">

                    <b-row>

                      <t-upload-files @uploadComplete="onUploadComplete"
                                      @onDownloadAllFiles="onDownloadAllFiles"
                                      @onSpecialTypeEvidenceFileOpenDialog="onSpecialTypeEvidenceFileOpenDialog"
                                      :qty-total="orderItems.length"
                                      :disable-webcam="disableWebcam"
                                      :continued-submit="continuedSubmit"
                                      :category-unique="categoryUnique" :detail-unique="detailUnique"
                                      :categoryId="categoryId" :subtitle="subtitle" :other-foreign-key="otherForeignKey"
                                      :special-type-evidence-file="specialTypeEvidenceFile"
                                      :evidence-file-entity="evidenceFileEntity"
                                      :path="path+'/upload'" :type="type" :foreign-key="foreignKey"/>


                    </b-row>
                  </b-col>

                  <b-col cols="12" class="mb-2" v-else>

                    <t-button v-if="typeImage" :sending="status === 'sending'" v-show="orderItems > 0"
                              @click="onDownloadAllFiles()"
                              class="ml-2">
                      <b-icon-arrow-down-circle/>
                      Download Todas
                    </t-button>

                  </b-col>


                </slot>

              </b-row>

            </validation-observer>

          </div>

        </transition>


        <div v-if="orderItems && orderItems.length > 0 && (type === 'D' || type === 'O')"
             class="d-flex border form-list-header">

          <span style="width: 45px"></span>

          <div class="text flex-grow-1">
            <b-row>
              <b-col :cols="field.cols" v-for="field in fields.filter((a) => {return 'label' in a})" :key="field.key">
                {{ field.label }}
              </b-col>
            </b-row>
          </div>

          <span style="width: 75px"></span>

        </div>

        <div v-show="!busyList">

          <div v-if="typeImage || typeUniqueImage">

            <draggable
                class="list-group list-container-images"
                v-model="orderItems"
                :handle="enabledDrag && command !== 'view' && !onlyView ? '.container_draggable' : '.not_drag'"
                ghostClass="ghost"
                @start="dragging = true"
                @end="draggableEnd">


              <transition-group name="fade-group-list" tag="ul">

                <div
                    class="image-card-draggable"
                    v-for="(item,index) in orderItems"
                    :key="item[primaryKeyColumn]"
                    :class="{'item-other-entity': otherEntity, 'integration-utilized':checkIntegrationStatus(item.integrationStatus),['container-image-orientation-'+item.fileEntity.orientation]:item.fileEntity.orientation !== undefined && item.orientation !== null}">

                  <div class="container_draggable"
                       :class="{'not-draggable':!enabledDrag || command === 'view' || onlyView}">


                    <div
                        style="width: 60%; font-size: 13px; line-height: 13px; padding-left: 5px; padding-top: 5px; position: relative; float: left">

                      <b>{{ (index + 1) | lpad(2) }}</b> <span
                        v-if="item.category !== undefined && item.category !== null && item.category !== ''"> - {{
                        item.category
                      }}</span>
                    </div>

                    <div style="width: 40%; position: relative; float: left; text-align: right; padding-right: 7px"
                         v-if="checkIntegrationStatus(item.integrationStatus)">
                      <b-icon-star-fill style="color:#ffb800"/>
                    </div>


                    <div class="container_buttons_image d-flex align-items-center justify-content-center">


                      <t-button secondary class="mr-2" @click="openImage('',index,true)">
                        <b-icon-search/>
                      </t-button>

                      <t-button danger v-if="userAuth.validation.validationDelete && command !== 'view' && !onlyView"
                                @click="itemDelete(item[primaryKeyColumn])">
                        <b-icon-trash/>
                      </t-button>


                    </div>

                    <div class="container_buttons_background">

                    </div>

                  </div>


                  <div
                      :class="{['container-image-orientation-'+item.fileEntity.orientation]:item.fileEntity.orientation !== undefined && item.fileEntity.orientation !== null}"
                      class="d-flex align-items-center">

                    <div class="image-blob" v-if="enablePublic">
                      <img :src="item.fileWebThumbnail"/>
                    </div>

                    <t-image-blob v-else-if="item.blob && !item.imageError" :blob="item.blob"/>

                    <div
                        v-else
                        class="image-placeholder"
                    >
                      <b-icon-image class="mb-1"></b-icon-image>
                      <small>Imagem indisponível</small>
                    </div>


                  </div>

                  <slot name="before-subtitle" :item="item">

                  </slot>

                  <div style="width: 100%; font-size: 10px; line-height: 10px">
                    {{ item.subtitle }}
                  </div>

                  <slot name="after-subtitle" :item="item">

                  </slot>


                </div>
              </transition-group>

            </draggable>


            <t-table v-if="enabledTableImagesDetails && orderItems.length > 0" :items="orderItems"
                     disable-link-primary-column
                     disable-actions-column
                     :fields="tableImageDetailsFields"
                     link-primary-column="position"
                     :busy="busy"
                     :primary-key-column="primaryKeyColumn">

              <template #first-column="{index}">

                <b>{{ ++index | lpad(2) }}</b>

              </template>


            </t-table>

          </div>

          <draggable v-else :list="orderItemsorderItems" class="list-group" handle=".handle">

            <transition-group type="transition" :name="!drag ? 'flip-list' : null">

              <li
                  class="list-group-item list-group-item-form-list line-hover"
                  :class="{'list-group-item-drag':enabledDrag  && command !== 'view' && !onlyView}"
                  v-for="(item,index) in orderItems"
                  :key="index">

                <div class="d-flex">

                  <b-icon-justify v-if="sortable" class="z-index-6 mr-2 mt-1 move handle" style="scale:1.2"/>

                  <div class="text flex-grow-1 mr-3">

                    <b-row>

                      <b-col :cols="field.cols" v-for="field in fields.filter((a) => {return 'label' in a})"
                             :key="field[primaryKeyColumn]">

                        <span v-if="field.key === 'nameOriginal'">

                          <b-link
                              @click="itemDownload(item[foreignKeyColumn],item[primaryKeyColumn],item.fileEntity.nameOriginal)">

                            <i v-if="item.fileEntity.extension === 'doc' || item.fileEntity.extension === 'docx'"
                               class="fa fa-file-word"></i>

                            <i v-else-if="item.fileEntity.extension === 'xlx' || item.fileEntity.extension === 'xlxs'"
                               class="fa fa-file-excel"></i>

                            <i v-else-if="item.fileEntity.extension === 'jpg' || item.fileEntity.extension === 'jpeg' || item.fileEntity.extension === 'png'"
                               class="fa fa-file-image"></i>

                            <i v-else-if="item.fileEntity.extension === 'pdf'"
                               class="fa fa-file-pdf"></i>

                            <i v-else class="fa fa-file"></i>

                            {{ item.fileEntity[field.key] }}

                          </b-link>

                        </span>

                        <span v-else-if="field.key === 'createdDate'">
                          {{ item.logControl[field.key] | datetime }}
                        </span>

                        <span v-else-if="field.key === 'category'">

                          <t-input
                              v-if="categoryOptions !== null && categoryOptions !== undefined && categoryOptions.length > 0"
                              :fixed="!userAuth.validation.validationUpdate || (command === 'view'  || onlyView)"
                              select-common
                              :options="categoryOptions"
                              @change="updateFile('doc',item)"
                              v-model="item[categoryColumn]"/>


                        </span>

                        <span v-else-if="field.key === 'subtitle'">

                          <t-input placeholder="Legenda"
                                   :fixed="!userAuth.validation.validationUpdate || (command === 'view'  || onlyView)"
                                   :cols="(categoryOptions !== null && categoryOptions !== undefined && categoryOptions.length > 0) ? 6 : 12"
                                   @focusout="updateFile('doc',item)"
                                   v-model="item.subtitle"/>

                        </span>

                        <span v-else-if="field.formatter === 'size'">{{ applyUnit(item.fileEntity[field.key]) }}</span>
                        <span v-else>{{ item.fileEntity[field.key] }}</span>

                      </b-col>

                    </b-row>

                  </div>

                  <b-icon-x-circle v-if="userAuth.validation.validationDelete && command !== 'view' && !onlyView"
                                   @click="itemDelete(item[primaryKeyColumn])"
                                   class="opacity-6-hover text-danger mt-1 hover"
                                   style="scale:1.2"/>

                </div>

              </li>

            </transition-group>

          </draggable>


        </div>

        <div class="container_loading_form" v-show="busyList">

          <div class="container_loading_form_card" style="height: 350px">

            <div class="gradient element-100" style="height: 30px; margin-top:5px"></div>
            <div class="gradient element-100" style="height: 30px; margin-top:5px"></div>
            <div class="gradient element-100" style="height: 30px; margin-top:5px"></div>

          </div>

        </div>

      </b-col>

    </transition>

    <div class="container_loading_form" v-show="busy || !thumbLoad">

      <div class="container_loading_form_card" style="height: 350px">

        <div class="gradient element-100" style="height: 30px"></div>

        <div class="gradient element-100" style="height: 100px"></div>

      </div>

    </div>


    <div v-show="enabledZoom"
         @click="enabledZoom = false"
         style="width: 100%; height: 100%; position: fixed; left: 0; top:0; z-index: 1000000; background-color: #0b0c0d !important">

      <div style="position: fixed; right: 20px; top: 10px; z-index: 1000001">

        <t-button danger class="mr-3" @click="enabledZoom = false">Fechar</t-button>

      </div>


      <t-image-blob
          style="cursor: zoom-out"
          class="align-self-center"
          v-if="blackoutImageZoomImage"
          :blob="blackoutImageZoomImage"/>

      <div
          v-else
          class="image-placeholder"
      >
        <b-icon-image class="mb-1"></b-icon-image>
        <small>Imagem indisponível</small>
      </div>


    </div>


  </div>

</template>
<script>
import 'tui-color-picker/dist/tui-color-picker.css';
import 'tui-image-editor/dist/tui-image-editor.css';
import tUploadFiles from "@/components/template/form/input/t-upload-files"
import tImageBlob from "@/components/template/theme/t-image-blob"
import ImageEditor from '@toast-ui/vue-image-editor/src/ImageEditor.vue';
import ui from "@/assets/scripts/ui"
import http from "@/services/config/http-common";
import TypeEvidenceCategoryService from "@/services/modules/checklist/TypeEvidenceCategory.service";
import TypeEvidenceServiceService from "@/services/modules/checklist/TypeEvidenceService.service";
import TypeEvidenceStatusService from "@/services/modules/checklist/TypeEvidenceStatus.service";
import functionsMixins from "@/mixins/page/functionsMixins";
import checklistService from "@/services/modules/checklist/Checklist.service";
import BusinessEvidenceFileEntity from "@/model/entities/modules/checklist/BusinessEvidenceFileEntity";

let state;
let blackoutImageShow;

const handler_image_gallery = (e) => {

  if (!blackoutImageShow) {
    state = null //Nula para reduzir impacto de memoria
  } else {

    if (e.key === 'ArrowLeft') {
      state.openImage("L", 0, false)
    } else if (e.key === 'ArrowRight') {
      state.openImage("R", 0, false)
    }

  }

}

export default {
  name: 't-page-form-upload',
  components: {tUploadFiles, tImageBlob, 'tui-image-editor': ImageEditor},
  mixins: [functionsMixins],
  data() {
    return {
      ui,
      blobUrl: null,
      drag: false,
      localStatus: "",
      type: "",
      errorList: [],
      orderItems: [],
      newOrderList: [],
      isInvalid: false,
      columnSize: 0,
      thumbLoad: false,
      dragging: false,
      enabledDrag: false,
      enabledZoom: false,
      blackoutImageZoom: false,
      blackoutImageZoomBusy: false,
      blackoutImageZoomImage: null,
      blackoutImageIndex: -1,
      blackoutImageOrientation: "L",
      blackoutImageSubtitle: "",
      blackoutImageCategoryId: 0,
      blackoutImageBackup: false,
      hasChanged: false,
      fields: [
        {key: "nameOriginal", label: "Arquivo", cols: "4"},
        {key: "subtitle", label: "Obs", cols: "3"},
        {key: "createdDate", label: "Data Upload", cols: "2", formatter: "datetime"},
        {key: "sizeKb", label: "Tamanho", cols: "2", formatter: "size"},
      ],
      tableImageDetailsFields: [
        {key: "position", label: "#", cols: "2"},
        {key: "subtitle", label: "Legenda", cols: "3"},
        {key: "logControl.createdDate", label: "Data Envio", cols: "2", formatter: "datetime"},
      ],
      /*---------------------------------------------------------*/
      /*ENTIDADES ESPECIAIS FORA DO PADRÃO*/
      typeEvidenceCategoryOptions: [],
      typeEvidenceServiceOptions: [],
      typeEvidenceStatusOptions: [],
      evidenceFileEntityUpdate: {
        checklistEnvironmentId: this.foreignKey,
        checklistEnvironmentEvidenceFileId: 0,
        subtitle: "",
        typeEvidenceCategoryId: 0,
        typeEvidenceServiceId: 0,
        typeEvidenceServiceNotFound: false,
        typeEvidenceServiceNotFoundOther: "",
        typeEvidenceStatusId: 0,
        environmentComplement: "",
      },
      /*---------------------------------------------------------*/
      businessEvidenceFileRequiredFieldsObject: new BusinessEvidenceFileEntity(),
      editorOpen: false,
      onSendingEditedImage: false,
      editorMounted: false,
      editorBlob: null,
      editorOptions: {
        usageStatistics: false,
        includeUI: {
          loadImage: {
            path: '', // Inicialmente vazio, será definido no onFileChange
            name: 'SampleImage'
          },
          locale: {
            Apply: "Aplicar",
            Arrow: "Seta",
            Arrow2: "Seta-2",
            Arrow3: "Seta-3",
            Blend: "Misturar",
            Blur: "Desfocar",
            Bold: "Negrito",
            Brightness: "Brilho",
            Bubble: "Balão",
            Cancel: "Cancelar",
            Center: "Centro",
            Circle: "Círculo",
            Color: "Cor",
            ColorFilter: "Filtro de Cor",
            Crop: "Cortar",
            Custom: "Personalizado",
            CustomIcon: "Ícone Personalizado",
            Delete: "Excluir",
            DeleteAll: "Excluir Tudo",
            Distance: "Distância",
            Download: "Salvar",
            Draw: "Desenhar",
            Emboss: "Relevo",
            Fill: "Fundo",
            Filter: "Filtro",
            Flip: "Virar",
            FlipX: "Virar X",
            FlipY: "Virar Y",
            Free: "Livre",
            Grayscale: "Escala de Cinza",
            Heart: "Coração",
            Icon: "Ícone",
            Invert: "Inverter",
            Italic: "Itálico",
            Left: "Esquerda",
            Load: "Carregar",
            LoadMaskImage: "Carregar Imagem de Máscara",
            Location: "Localização",
            Mask: "Máscara",
            Multiply: "Multiplicar",
            Noise: "Ruído",
            Pixelate: "Pixelar",
            Polygon: "Polígono",
            Range: "Intervalo",
            Rectangle: "Retângulo",
            Redo: "Refazer",
            RemoveWhite: "Remover Branco",
            Reset: "Redefinir",
            Right: "Direita",
            Rotate: "Girar",
            Sepia: "Sépia",
            Sepia2: "Sépia-2",
            Shape: "Forma",
            Sharpen: "Nitidez",
            Square: "Quadrado",
            Star1: "Estrela-1",
            Star2: "Estrela-2",
            Straight: "Reto",
            Stroke: "Contorno",
            Text: "Texto",
            TextSize: "Tamanho do Texto",
            Threshold: "Limite",
            Tint: "Matiz",
            Triangle: "Triângulo",
            Underline: "Sublinhado",
            Undo: "Desfazer",
            Value: "Valor"
          },
          options: {
            stroke: 10,
          },
          theme: {'common.fontFamily': 'Arial, sans-serif',},
          menu: ['shape', 'draw', 'text', 'icon', 'filter', 'flip'],
          initMenu: 'icon',
          icon: {
            path: '/icons/', // onde estão seus SVGs
            items: {
              'diamante': 'icone-diamante.svg',
            }
          },
          buttons: {
            loadButton: false,     // Oculta o botão "Load"
            downloadButton: false  // Oculta o botão "Download"
          },
          menuBarPosition: 'left',
        },
      },
    }
  },
  props: {
    status: String,
    command: {
      type: String,
      default: 'insert'
    },
    messageNotRecord: {
      type: String,
      default: '',
    },
    disableWebcam: Boolean,
    enabledTableImagesDetails: Boolean,
    otherEntity: Boolean,
    title: String,
    userAuth: Object,
    items: Array,
    sortable: Boolean,
    path: String,
    primaryKey: Number,
    foreignKey: Number,
    specialTypeEvidenceFile: Boolean,
    businessEvidenceFileRequiredFields: {
      type: String,
      default: 'N',
    },
    businessEvidenceFileLabelOrderFields: {
      type: String,
      default: '',
    },
    evidenceFileEntity: Object,
    categoryUnique: {
      type: String,
      default: '',
    },
    detailUnique: {
      type: String,
      default: ""
    },
    foreignKeyColumn: {
      type: String,
      required: true,
    },
    primaryKeyColumn: {
      type: String,
      required: true,
    },
    continuedSubmit: Boolean,
    onlyView: Boolean,
    enablePublic: Boolean,
    busy: {//busy principal
      type: Boolean,
      default: false,
    },
    busyForm: {//busy somente do formulário na parte superior
      type: Boolean,
      default: false,
    },
    busyList: {//busy somente da listagem
      type: Boolean,
      default: false,
    },
    typeImage: Boolean,
    typeUniqueDoc: Boolean,
    typeUniqueImage: Boolean,
    subtitle: {
      type: String,
      default: ""
    },
    categoryColumn: {
      type: String,
      default: ""
    },
    categoryId: {
      type: Number,
      default: 0
    },
    otherForeignKey: {
      type: Number,
      default: 0
    },
    categoryOptions: Array,
  },

  async mounted() {

    this.localStatus = this.status
    this.orderItems = this.items

    this.enabledDrag = this.userAuth.validation.validationUpdate && this.command !== 'view' && !this.onlyView

    this.businessEvidenceFileRequiredFieldsObject = checklistService.onBusinessEvidenceFileRequiredFieldsFromString(this.businessEvidenceFileRequiredFields, this.businessEvidenceFileLabelOrderFields)

    if (this.typeImage) {
      this.type = "I"
    } else if (this.typeUniqueImage) {
      this.type = "E"
    } else if (this.typeUniqueDoc) {
      this.type = "O"
    } else {
      this.type = "D"
    }

    if (this.categoryColumn !== '') {

      /*Sobrepor campos para acrescentar categorização*/
      this.fields = [
        {key: "nameOriginal", label: "Arquivo", cols: "3"},
        {key: "category", label: "Categoria", cols: "2"},
        {key: "subtitle", label: "Obs", cols: "3"},
        {key: "createdDate", label: "Data Envio", cols: "2", formatter: "datetime"},
        {key: "sizeKb", label: "Tamanho", cols: "2", formatter: "size"},
      ]

    }

    if (this.specialTypeEvidenceFile) {

      await TypeEvidenceCategoryService.selectList("").then((list) => {
        this.typeEvidenceCategoryOptions = list
      }).catch(error => this.responseError(error))

      await TypeEvidenceServiceService.selectList("").then((list) => {
        this.typeEvidenceServiceOptions = list
      }).catch(error => this.responseError(error))

      await TypeEvidenceStatusService.selectList("").then((list) => {
        this.typeEvidenceStatusOptions = list
      }).catch(error => this.responseError(error))

    }

    await this.getBlobItems()


  },
  computed: {

    onSending() {
      return this.status === "sending"
    },


  },
  methods: {

    checkIntegrationStatus(integrationStatus) {

      if (this.objValid(integrationStatus) && integrationStatus === 1) {
        return true
      } else {
        return false
      }

    },

    async downloadImage(item) {

      await http.download(this.path + "/download/" + item[this.foreignKeyColumn] + "/" + item[this.primaryKeyColumn], item.fileEntity.nameOriginal)
          .catch(error => this.responseError(error))

    },

    async confirmDeleteImage(item) {
      console.log('Validar se possui acesso e receber da tela anterior. Simplesmente enviar emit por enquanto', item)
    },

    async zoomImage() {
      this.enabledZoom = true
    },


    onBlackoutImage(show) {

      blackoutImageShow = show

      if (show) {
        state = this
        document.addEventListener('keydown', handler_image_gallery)
      } else {
        this.enabledZoom = false
        document.removeEventListener('keydown', handler_image_gallery)

        //Precisamos melhorar para saber se houve alguma mudança para poder realizar um novo get
        if (this.hasChanged)
          this.$emit("onRequestList")
      }

    },

    updateFile(origin, record, showMsg = true, refresh = false) {

      let item
      let updateFile

      if (origin === 'image') {

        item = this.orderItems[this.blackoutImageIndex]

        updateFile = {
          id: item[this.primaryKeyColumn],
          foreignKey: item[this.foreignKeyColumn],
          categoryId: this.blackoutImageCategoryId,
          subtitle: this.blackoutImageSubtitle,
        }

      } else if (origin === 'doc') {

        item = record

        if (this.categoryColumn !== '') {

          updateFile = {
            id: item[this.primaryKeyColumn],
            foreignKey: item[this.foreignKeyColumn],
            categoryId: item[this.categoryColumn],
            subtitle: item.subtitle,
          }

        } else {

          updateFile = {
            id: item[this.primaryKeyColumn],
            foreignKey: item[this.foreignKeyColumn],
            subtitle: item.subtitle,
          }

        }

      }

      if (item !== undefined && item !== null) {

        http.put(this.path, updateFile).then(async () => {

          //Atualiza os indices conforme nova ordem
          if (showMsg)
            ui.toast(this, "Arquivo atualizado", "Sucesso na atualização do arquivo!")

          if (refresh)
            this.$emit("onRequestList")


          this.hasChanged = true

        }).catch(error => {

          this.blackoutImageZoom = false
          ui.generalResponseError(this, error)

        })

      }


    },

    /*-----------------------------*/
    /*ATUALIZAÇÃO DE ENTIDADE ESPECIAIS*/
    async updateEvidenceFile(showMsg = true) {

      const entity = {
        checklistEnvironmentEvidenceFileId: this.evidenceFileEntityUpdate.checklistEnvironmentEvidenceFileId,
        checklistEnvironmentId: this.evidenceFileEntityUpdate.checklistEnvironmentId,
        typeEvidenceCategoryId: this.evidenceFileEntityUpdate.typeEvidenceCategoryId,
        typeEvidenceServiceId: this.evidenceFileEntityUpdate.typeEvidenceServiceId,
        typeEvidenceServiceNotFound: this.evidenceFileEntityUpdate.typeEvidenceServiceNotFound,
        typeEvidenceServiceNotFoundOther: this.evidenceFileEntityUpdate.typeEvidenceServiceNotFoundOther,
        typeEvidenceStatusId: this.evidenceFileEntityUpdate.typeEvidenceStatusId,
        environmentComplement: this.evidenceFileEntityUpdate.environmentComplement,

        subtitle: this.evidenceFileEntityUpdate.subtitle,
      }

      await http.put(this.path, entity).then(async () => {

        //Atualiza os indices conforme nova ordem
        if (showMsg) {
          ui.toast(this, "Foto atualizada", "Sucesso na atualização do arquivo!")

        }


      }).catch(error => {

        this.blackoutImageZoom = false
        ui.generalResponseError(this, error)

      })
    },


    async openImage(changePosition, index, openBlackout) {

      this.hasChanged = false

      let indexImage = index

      if (changePosition !== '' && this.orderItems.length < 2) {
        return false

      }

      if (changePosition === 'L') {

        if (!this.onlyView) {

          //Salva antes de avançar
          if (this.specialTypeEvidenceFile) {
            await this.updateEvidenceFile(false);
          } else {
            await this.updateFile('image', '', false, false)
          }

        }

        if (this.blackoutImageIndex > 0) {
          this.blackoutImageIndex--
          indexImage = this.blackoutImageIndex
        } else {
          indexImage = this.orderItems.length - 1
        }


      } else if (changePosition === 'R') {

        if (!this.onlyView) {

          //Salva antes de avançar
          if (this.specialTypeEvidenceFile) {
            await this.updateEvidenceFile(false);
          } else {
            await this.updateFile('image', '', false, false)
          }

        }

        if (this.blackoutImageIndex < this.orderItems.length - 1) {
          this.blackoutImageIndex++
          indexImage = this.blackoutImageIndex
        } else {
          indexImage = 0
        }

      }

      const id = this.orderItems[indexImage][this.primaryKeyColumn]
      const foreignKey = this.orderItems[indexImage][this.foreignKeyColumn]

      this.blackoutImageIndex = indexImage
      this.blackoutImageZoomImage = null
      this.blackoutImageZoomBusy = true
      this.blackoutImageSubtitle = "" //Valor padrão
      this.blackoutImageOrientation = "L" //Valor padrão
      this.blackoutImageCategoryId = 0 //Valor padrão
      this.blackoutImageBackup = this.orderItems[indexImage]?.backup ?? false;

      if (indexImage !== undefined && indexImage >= 0) {

        if (this.orderItems.length > 0 && this.orderItems[indexImage] !== null) {

          const subtitle = this.orderItems[indexImage].subtitle
          const categoryId = this.orderItems[indexImage][this.categoryColumn]

          if (this.specialTypeEvidenceFile) {
            this.evidenceFileEntityUpdate = this.orderItems[indexImage]
          }

          if (subtitle !== null && subtitle !== undefined && subtitle !== '') {
            this.blackoutImageSubtitle = subtitle
          }

          if (this.orderItems[indexImage].fileEntity) {
            if (this.orderItems[indexImage].fileEntity.orientation !== undefined && this.orderItems[indexImage].fileEntity.orientation !== null) {
              this.blackoutImageOrientation = this.orderItems[indexImage].fileEntity.orientation
            }
          }


          if (this.orderItems[indexImage].orientation !== undefined && this.orderItems[indexImage].orientation !== null) {

            this.blackoutImageOrientation = this.orderItems[indexImage].orientation
          }

          if (categoryId !== null && categoryId !== undefined && categoryId !== '') {
            this.blackoutImageCategoryId = categoryId
          }

        }

      }

      if (openBlackout) {
        this.blackoutImageZoom = true
      } else {
        this.blackoutImageZoomBusy = false
      }


      if (this.enablePublic) {

        this.blackoutImageZoomImage = await ui.loadImageAsBlob(this.orderItems[indexImage].fileWebFull)
        this.blackoutImageZoomBusy = false

      } else {
        await http.image(this.srcImage(id, foreignKey, false)).then((blob) => {
          this.blackoutImageZoomImage = blob
          this.blackoutImageZoomBusy = false
        })
      }


    },

    async getBlobItems() {

      this.thumbLoad = false

      if (!this.enablePublic) {

        //Ler somente se não estiver habilitado para leitura publica

        for (let item of this.orderItems) {

          await http
              .image(
                  this.srcImage(
                      item[this.primaryKeyColumn],
                      item[this.foreignKeyColumn],
                      true
                  )
              )
              .then((blob) => {
                item.blob = blob
                item.imageError = false
              })
              .catch(() => {
                item.blob = null
                item.imageError = true
              })
        }

      }

      this.thumbLoad = true

    },


    srcImage(id, foreignKeyColumn, thumbnail) {

      let src = this.path + "/image/" + foreignKeyColumn + "/" + id + "?" + Date.now()

      if (thumbnail) {
        src += "/?variant=thumbnail"
      }


      return src

    },

    draggableEnd() {

      this.dragging = false

      http.post(this.path + "/changeOrder", this.orderItemsReduce()).then(() => {

        //Atualiza os indices conforme nova ordem
        ui.toast(this, "Ordem atualizada!", "Ordem alterada com sucesso")

      }).catch(async () => {
        this.$emit("onRequestList") //Enviar para o componente principal solicitar atualização de listagem
        ui.msgError(this, "Erro ao tentar atualizar a ordem das imagens. Tente novamente e caso o problema persistir informe nosso suporte técnico.");
      })

    },

    applyUnit(size) {

      if (size > 1000) {
        return (Math.round((size / 1000) * 10) / 10).toLocaleString('pt-br') + " MB"
      } else {
        return size + " KB"
      }

    },

    checkValidation() {
      //return ui.hasValidation(this.command,this.userAuth.validation)

      return ((this.command === 'insert' && this.userAuth.validation.validationCreate) ||
          (this.command === 'update' && this.userAuth.validation.validationUpdate) ||
          (this.command === 'delete' && this.userAuth.validation.validationDelete) ||
          (this.command === "view" && this.userAuth.validation.validationRead) || this.onlyView)

    },

    orderItemsReduce() {

      let newListOrder = []

      for (const item of this.orderItems) {
        newListOrder.push(item[this.primaryKeyColumn])
      }

      return {
        id: this.foreignKey,
        orderList: newListOrder
      }

    },

    onUploadComplete() {
      this.$emit('onUploadComplete')
    },

    onSpecialTypeEvidenceFileOpenDialog() {
      this.$emit('onSpecialTypeEvidenceFileOpenDialog')
    },

    async onDownloadAllFiles() {

      let index = 0

      for (const item of this.orderItems) {

        index++

        await http.download(this.path + "/download/" + item[this.foreignKeyColumn] + "/" + item[this.primaryKeyColumn], index + '.' + item.fileEntity.extension)
            .catch(error => this.responseError(error))

      }

    },

    itemDownload(foreignKey, primaryKey, nameOriginal) {

      this.$emit('itemDownload', foreignKey, primaryKey, nameOriginal)

    },
    itemDelete(id, openImage = false) {

      ui.msgConfirmDelete(this, () => {

        if (openImage) {
          this.blackoutImageZoom = false
        }


        this.$emit('onItemDelete', id)
      })

    },
    setReset() {

    },
    onSubmit() {

      //Avisa o pai que mudou o status para submetido
      this.localStatus = "subject"
      this.$parent.status = "subject"

      this.$refs.validationFormList.validate().then(success => {

        if (!success) {
          return;
        }

        this.$emit('onSubmit')

      });

    },
    setSending() {
      this.status = "sending"
    },

    /*/////////////////////////////////////*/

    closeEditor() {
      this.editorOpen = false
      this.$emit("onRequestList") //Enviar para o componente principal solicitar atualização de listagem
    },

    rotate(type) {

      const item = this.orderItems[this.blackoutImageIndex]

      const post = {
        id: item[this.primaryKeyColumn],
        foreignKey: item[this.foreignKeyColumn],
      }

      http.post(this.path + "/rotate/" + type, post).then(async (response) => {

        //Atualiza os indices conforme nova ordem
        ui.toast(this, "Imagem rotacionada", "Imagem rotacionada com sucesso!")

        if (response.data !== null) {

          if (this.objValid(response.data.fileWebFull))
            this.orderItems[this.blackoutImageIndex].fileWebFull = response.data.fileWebFull

          if (this.objValid(response.data.fileWebMedium))
            this.orderItems[this.blackoutImageIndex].fileWebMedium = response.data.fileWebMedium

          if (this.objValid(response.data.fileWebThumnail))
            this.orderItems[this.blackoutImageIndex].fileWebThumnail = response.data.fileWebThumnail

        }


        this.editorOpen = false

        await this.openImage('', this.blackoutImageIndex, false)

        setTimeout(()=>{
          this.openEditorPhoto()
        },200)


        /* this.blackoutImageZoomImage = null
         this.blackoutImageZoomBusy = true

         await http.image(this.srcImage(post.id, post.foreignKey, false)).then((blob) => {
           this.blackoutImageZoomImage = blob
           this.blackoutImageZoomBusy = false
         })*/


      }).catch(async () => {

        this.setIsLoadingPage(false)
        this.editorOpen = false
        this.onSendingEditedImage = false

        this.$emit("onRequestList") //Enviar para o componente principal solicitar atualização de listagem
        ui.msgError(this, "Erro ao tentar recuperar do backup a imagem");
      })

    },

    confirmBackup() {

      ui.msgConfirm(this, 'Recuperação de imagem', 'Tem certeza que deseja desfazer a edição realizada na web e restaurar a imagem?', () => {

        const item = this.orderItems[this.blackoutImageIndex]

        const post = {
          id: item[this.primaryKeyColumn],
          foreignKey: item[this.foreignKeyColumn],
        }

        http.post(this.path + "/backup", post).then(() => {

          //Atualiza os indices conforme nova ordem
          ui.toast(this, "Imagem restaurada!", "Imagem restaurada com sucesso antes da edição na web!")

          this.editorOpen = false
          this.openImage('', this.blackoutImageIndex, false, true)


          this.$emit("onRequestList") //Enviar para o componente principal solicitar atualização de listagem


        }).catch(async () => {

          this.editorOpen = false
          this.onSendingEditedImage = false

          this.$emit("onRequestList") //Enviar para o componente principal solicitar atualização de listagem
          ui.msgError(this, "Erro ao tentar recuperar do backup a imagem");
        })


      })


    },

    saveEditedImage() {
      // Acessa a instância do editor
      const editorInstance = this.$refs.tuiImageEditor.editorInstance;

      if (editorInstance) {
        // Gera a imagem editada como uma data URL
        const dataURL = editorInstance.toDataURL({
          format: 'jpeg',  // Formato desejado: 'jpeg' ou 'png'
          quality: 0.9     // Qualidade (0 a 1), aplicável para JPEG
        });

        this.onSendingEditedImage = true

        const item = this.orderItems[this.blackoutImageIndex]

        const editorFile = {
          id: item[this.primaryKeyColumn],
          foreignKey: item[this.foreignKeyColumn],
          file: dataURL,
        }

        http.post(this.path + "/editor", editorFile).then(() => {


          this.editorOpen = false

          //Atualiza a imagem já editada localmente
          this.blackoutImageZoomImage = dataURL

          //Agora passará a ter backup, pois foi editada
          this.blackoutImageBackup = true
          this.orderItems[this.blackoutImageIndex].backup = true

          //Atualiza os indices conforme nova ordem
          ui.toast(this, "Imagem atualizada!", "Imagem atualizada com sucesso!")

          this.$emit("onRequestList") //Enviar para o componente principal solicitar atualização de listagem


          this.onSendingEditedImage = false

        }).catch(async () => {

          this.editorOpen = false
          this.onSendingEditedImage = false

          this.$emit("onRequestList") //Enviar para o componente principal solicitar atualização de listagem
          ui.msgError(this, "Erro ao tentar editar a imagem");
        })

      } else {
        console.warn('Instância do editor não está disponível.');
        return null;
      }
    },

    openEditorPhoto() {

      this.editorBlob = this.blackoutImageZoomImage

      this.editorOptions.includeUI.loadImage.path = this.blackoutImageZoomImage

      setTimeout(() => {
        this.editorOpen = true
        this.blackoutImageZoom = false
      }, 200)

    },


  }
  ,
  watch: {
    status(value) {
      this.localStatus = value
    },
    items(value) {
      this.orderItems = value
    },
    /*orderItems(){
      this.getBlobItems()
    },*/
    orderItems: {
      deep: false,
      handler() {
        // não refaça thumbs enquanto estiver arrastando
        if (this.dragging) return
        // evita rodar no mesmo tick da mutação do Sortable
        this.$nextTick(() => this.getBlobItems())
      }
    },
    userAuth(value) {
      this.enabledDrag = value.validation.validationUpdate
    },
  }
}
</script>
<style>
.image-card-draggable {
  position: relative;
  float: left;
  padding: 5px;
  margin: 5px;
  border-radius: 3px;
  border: solid 1px #e1e1e1;
  width: 200px;
  height: 215px;
  padding-top: 15px;
  background: center center no-repeat;
  background-size: 90%;
  overflow: hidden;
}


.blackout-image-full-orientation-P {
  max-width: 20vh;
  overflow: hidden;
}

.blackout-image-full-orientation-L {
  max-width: 60vh;
  width: auto !important;
  overflow: hidden;
}

/*@media (max-width: 576px) {
  .blackout-image-full-orientation-P, .blackout-image-full-orientation-L {
    max-height: 20vh !important;
  }
}*/

.container-image-orientation-P2 {
  height: calc(80% - 35px);
  max-width: 150px;
  margin-top: 5px;
}

.container-image-orientation-L2 {
  height: calc(100% - 35px);
  margin-top: 5px;
}

.container_draggable, .container_buttons_image, .container_buttons_background {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  transition: all 0.2s;
  z-index: 2;
}

.container-blackout .container-title-text, .container-blackout label {
  color: #FFFFFF !important;
}

.container-blackout-white .container-title-text, .container-blackout-white label {
  color: #000 !important;
}

.container-blackout-white .container-buttons-upload-images {


}


.container_buttons_image, .container_buttons_background {
  visibility: hidden !important;
  transition: all 0.2s;
}

.container_buttons_image {
  z-index: 3;

}

.container_buttons_background {
  opacity: 0.8;
  background-color: #FFFFFF;
  z-index: 2;
}


.container_draggable:hover .container_buttons_background, .container_draggable:hover .container_buttons_image {
  visibility: visible !important;
  cursor: move;
}

.item-other-entity {

}

.integration-utilized {
  border: solid 3px #ffb800 !important;
}

.tui-image-editor-container label {
  color: #FFFFFF !important;
}

.tui-image-editor-container {
  font-family: Arial, sans-serif !important;
  z-index: 1039 !important;
}

.container_draggable.not-draggable:hover .container_buttons_background, .container_draggable.not-draggable:hover .container_buttons_image {
  cursor: auto !important;
}

.image-card-draggable img, .image-card-draggable .image-blob {
  width: 100%;
  max-height: 60vh;
  text-align: center;
}

.list-container-images ul {
  margin: 0px !important;
  padding: 5px !important;
}

.form-list-header {
  background-color: #fafafa;
  border-top-right-radius: 3px;
  border-top-left-radius: 3px;
  font-weight: bold;
  font-size: 12px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.form-list-header + .list-group .list-group-item {
  border-radius: 0px;
}

.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #0075b0 !important;
}

.list-group {
  min-height: 20px;
}

.list-group-item-drag {
  cursor: move;
}

.list-group-item i {
  cursor: pointer;
}

.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}


/* 1. declare transition */
.fade-group-list-move,
.fade-group-list-enter-active,
.fade-group-list-leave-active {
  transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
}

/* 2. declare enter from and leave to state */
.fade-group-list-enter-from,
.fade-group-list-leave-to {
  opacity: 0;
  transform: scaleY(0.01) translate(30px, 0);
}

/* 3. ensure leaving items are taken out of layout flow so that moving
      animations can be calculated correctly. */
.fade-group-list-leave-active {
  position: absolute;
}

.image-card-draggable {
  position: relative;
  display: flex; /* empilha verticalmente: imagem + legenda */
  flex-direction: column;
  border: 1px solid #e7e7e7;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
  transition: transform .12s ease, box-shadow .12s ease;
}

.image-card-draggable:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, .08);
}


.list-container-images ul {
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* 4 colunas fixas */
  gap: 12px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.image-card-draggable {
  /* pare de forçar largura/float */
  float: none;
  width: auto;
  height: auto;
  border: 1px solid #e7e7e7;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

/* Imagem dentro do card */
.image-card-draggable .image-blob img {
  aspect-ratio: 4 / 5; /* altura consistente */
  object-fit: cover;
  display: block;
}
</style>
